import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';
import './replacement_modal.css'
import Modal from '../Home/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { IStore } from '../../redux/store/IStore';
import { setReplacementsModal } from '../../redux/actions/actions';
import Search from '@material-ui/icons/Search';
import { deleteReplacement, getReplacements, ILocalReplacement, INewReplacement, LocalReplacements, patchReplacement, postNewReplacement, ReplacementsList, tokenize } from '../../api/ReplacementsService';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import { enqueueSnackbar } from 'notistack';
import DeleteIcon from '@material-ui/icons/Delete';
import UndoIcon from '@material-ui/icons/Undo';

const initialReplacement: ILocalReplacement = {id: -1, source: "", target: ""}
const ReplacementModal = () => {
    const dispatch = useDispatch();
    
    const [replacementsFilter, setReplacementsFilter] = useState<string>("")
    const [localReplacementsList, setLocalReplacementsList] = useState<LocalReplacements>([])
    const [localReplacementsDeletedIds, setLocalReplacementsDeletedIds] = useState<number[]>([])
    const [newLocalReplacement, setNewLocalReplacement] = useState<ILocalReplacement>(initialReplacement)
    
    const replacementsFileInputRef = useRef<HTMLInputElement>(null);
    const originalLocalReplacementList = useRef<LocalReplacements>([])

    const [updating, setUpdating] = useState<boolean>(false)

    const {
        visible
    } = useSelector((store: IStore) => store.replacementsModal);

    const hideReplacementsModal = () => dispatch(setReplacementsModal({
        visible: false,
    }))

    const sortLocalReplacements = (arr: LocalReplacements): LocalReplacements => {
        return [...arr].sort((a, b) =>
            a.source.localeCompare(b.source, undefined, { sensitivity: 'base' })
    )}

    const handleReplacementFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
        setReplacementsFilter(event.target.value)
    }

    const handleExistingReplacementTarget = (event: ChangeEvent<HTMLInputElement>, id: number) => {
        setLocalReplacementsList(current => {
            const index = current.findIndex(iterationReplacement => iterationReplacement.id === id);
            
            if (index < 0) return current;
            const cloned = [...current];

            cloned[index] = {
                ...cloned[index],
                target: event.target.value,
            }

            return cloned//sortLocalReplacements(cloned);
        })
    }

    const handleReplacementSourceChange = (event: ChangeEvent<HTMLInputElement>, id: number) => {
        setLocalReplacementsList(current => {
            const index = current.findIndex(iterationReplacement => iterationReplacement.id === id);
            
            if (index < 0) return current;
            const cloned = [...current];

            cloned[index] = {
                ...cloned[index],
                source: event.target.value
            }
            return cloned//sortLocalReplacements(cloned);
        })
    }

    const replacementsWrapper = async () => {
        try {
        const response = await getReplacements();
        const mappedReplacements = response.data.map(replacement => {
            const sourceText = replacement.source.reduce((acc, cur) => {
                return acc + (cur.spaceBefore ? ' ' : '') + cur.text;
            }, '');
            return {
                id: replacement.id,
                target: (replacement.target.spaceBefore ? " " : "") + replacement.target.text,
                source: sourceText
            }
            
        })

        originalLocalReplacementList.current = mappedReplacements
        setLocalReplacementsList(mappedReplacements)//sortLocalReplacements(mappedReplacements));
        setLocalReplacementsDeletedIds([])
        } catch (error) {
        console.log(error);
        }
    }

    const handleNewSourceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewLocalReplacement(current => {
            return {
                ...current,
                source: event.target.value
            }
        })
    }
    const handleNewTargetChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewLocalReplacement(current => {
            return {
                ...current,
                target: event.target.value
            }
        })
    }

    const addReplacementToList = () => {
        setLocalReplacementsList(current => {
          const replacementExists = current.filter(replacement => replacement.source === newLocalReplacement.source).length > 0
          if (replacementExists) {
            enqueueSnackbar("Zamenjava že obstaja.", { variant: "error" })
            return current;
          }
          current.push({...newLocalReplacement, id: -Date.now()})
          setNewLocalReplacement(initialReplacement)
          return current//sortLocalReplacements(current);
        })
    }

    const deleteLocalReplacement = (id: number) => {
        setLocalReplacementsDeletedIds(current => [...current, id]);
    }

    const recoverLocalReplacement = (id: number) => {
        setLocalReplacementsDeletedIds(current => current.filter(iterationId => iterationId !== id))
    }

const exportReplacementsTsv = useCallback(() => {
    const tsvContent = exportBoostedPhrasesToTSV(localReplacementsList);

    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const filename = `zamenjave_${pad(now.getDate())}_${pad(now.getMonth() + 1)}_${now.getFullYear()}_${pad(now.getHours())}_${pad(now.getMinutes())}.tsv`;

    const blob = new Blob([tsvContent], { type: 'text/tab-separated-values;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.click();

    URL.revokeObjectURL(url);
}, [localReplacementsList]);

const exportBoostedPhrasesToTSV = (replacements: LocalReplacements) => {
    const headers = "source\ttarget";
    const rows = replacements.map(replacement => {
        const source = replacement.source;
        const target = replacement.target;
        return `${source}\t${target}`;  // Use tab as delimiter
    });

    return [headers, ...rows].join("\n");
};

const importReplacementTsv = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
        const text = e.target?.result as string;
        const lines = text.trim().split('\n');

        const newList: LocalReplacements = [];

        if (lines.length < 2) {
            enqueueSnackbar("Datoteka ni v veljavnem formatu!", {variant: 'error'})
            return;
        }

        const line = lines[0];
        const splitter = /\t/;
        const [headerSource, headerTarget] = line.split(splitter, 2);
        if (headerSource !== "source" && headerTarget !== "target") {
            enqueueSnackbar("Datoteka ni v veljavnem formatu!", {variant: 'error'})
            return;
        }
        for (let i = 1; i < lines.length; i++) {
            const line = lines[i];
            const splitter = /\t/;
            const [rawSource, rawTarget] = line.split(splitter, 2);

            const importedReplacement: ILocalReplacement = {
                id: -(Date.now() + i),
                source: rawSource,
                target: rawTarget,
            };

            newList.push(importedReplacement);
        }

        localReplacementsList.forEach(replacement => {
            const replacedIndex = newList.findIndex(newReplacement => {
                return newReplacement.source === replacement.source;
            });
            if (replacedIndex < 0) {
                newList.push(replacement);
            } else {
                newList[replacedIndex].id = replacement.id;
            }
        });

        const filtered = newList.filter(element => element.source !== undefined && element.target !== undefined);
        setLocalReplacementsList(filtered)//sortLocalReplacements(filtered));
        event.target.value = '';
    };

    reader.readAsText(file);
};

    const saveReplacements = async () => {
        setUpdating(true);
        try {
            const filterExistingToDelete = localReplacementsDeletedIds.filter(id => id > -1);
            const newReplacements = localReplacementsList.filter(replacement => replacement.id < 0)
            const filterExistingToPatch = localReplacementsList.filter(replacement => replacement.id > -1)

            for (let deleteBoostIndex = 0; deleteBoostIndex < filterExistingToDelete.length; deleteBoostIndex++) {
                await deleteReplacement(filterExistingToDelete[deleteBoostIndex])
            }

            for (let newReplacementIndex = 0; newReplacementIndex < newReplacements.length; newReplacementIndex++) {
                if (localReplacementsDeletedIds.includes(newReplacements[newReplacementIndex].id)) continue;

                const currentReplacement = newReplacements[newReplacementIndex]
                
                const tokenizedSource = tokenize(currentReplacement.source)
                
                const postReplacement: INewReplacement = {
                    source: tokenizedSource,
                    target: {
                        text: currentReplacement.target,
                        spaceBefore: true,
                    }
                }

                await postNewReplacement(postReplacement)
            }

            for (let patchBoostIndex = 0; patchBoostIndex < filterExistingToPatch.length; patchBoostIndex++) {
                const replacement = localReplacementsList[patchBoostIndex]        
                if (filterExistingToDelete.includes(replacement.id)) continue;
                            
                const original = originalLocalReplacementList.current.find(iterationBoostPhrase => iterationBoostPhrase.id === replacement.id)
                if (!original) continue;
                            
                let updateObj = {id: replacement.id}
                if (original.source === replacement.source && original.target === replacement.target) continue;
                if (original.source !== replacement.source) updateObj["source"] = tokenize(replacement.source)
                if (original.target !== replacement.target) updateObj["target"] = replacement.target
                            
                await patchReplacement(updateObj)
            }

            await replacementsWrapper();
        } catch (error) {
            console.log(error);
        }

        setUpdating(false);
    }

    useEffect(() => {
        if (visible) {
            replacementsWrapper();
        }
    }, [visible])
      
    return (
      <Modal visible={visible} title='Zamenjave' closeModal={hideReplacementsModal}>
        <div id="replacements-container">
          <div id="replacements-toolbar-container">
            <Search />
            <input id="replacements-filter-field" placeholder='Išči...' value={replacementsFilter} onChange={handleReplacementFilterChange}/>
          </div>

          <div id="replacements-table-container">
            <table id="replacements-table">
              <thead>
                <tr>
                  <th className='replacements-th'>Iz teksta</th>
                  <th className='replacements-th'>V tekst</th>
                  <th className='replacements-th'>Akcije</th>
                </tr>
              </thead>

              <tbody>
                {localReplacementsList
                .filter(replacement => replacement.target.toLowerCase().includes(replacementsFilter.toLowerCase()))
                .map(replacement => {
                    const isLocalyDeleted = localReplacementsDeletedIds.includes(replacement.id)
                    const newelyAdded = replacement.id < 0
                    let backgroundColor = "transparent"
                    
                    const originalReplacement = originalLocalReplacementList.current.filter(current => current.id === replacement.id)
                    if (originalReplacement.length > 0 && (originalReplacement[0].target !== replacement.target || originalReplacement[0].source !== replacement.source)) {
                        backgroundColor = "#fff7c29a"
                    }
                    
                    if (newelyAdded) backgroundColor = "#31a0ff3f";
                    if (isLocalyDeleted) backgroundColor = "#ff66663f";

                    return (
                        <tr style={{ backgroundColor }}>
                        <td className='replacements-td'>
                            <input disabled={isLocalyDeleted} placeholder='Vnesite zamenjavo...' onChange={event => handleReplacementSourceChange(event, replacement.id)} value={replacement.source}/>
                        </td>
                        <td className='replacements-td'>
                            <input disabled={isLocalyDeleted} placeholder='Vnesite zamenjavo...' onChange={event => handleExistingReplacementTarget(event, replacement.id)} value={replacement.target} />
                        </td>
                        <td className='boost-td'>
                            {isLocalyDeleted && (
                                <Tooltip title="Ponastavi" arrow placement='top'>
                                    <button onClick={() => recoverLocalReplacement(replacement.id)}>
                                        <UndoIcon />
                                    </button>
                                </Tooltip>
                                ) || (
                                <Tooltip title="Izbriši" arrow placement='top'>
                                    <button onClick={() => deleteLocalReplacement(replacement.id)}>
                                        <DeleteIcon className='delete_word_boost_icon' />
                                    </button>
                                </Tooltip>
                            )}
                        </td>
                        </tr>
                    )
                })}
                <tr>
                  <td className='replacements-td'>
                    <input placeholder='Vnesite zamenjavo...' onChange={handleNewSourceChange} value={newLocalReplacement.source} />
                  </td>
                  <td className='replacements-td'>
                    <input placeholder='Vnesite zamenjavo...' onChange={handleNewTargetChange} value={newLocalReplacement.target} />
                  </td>
                  <td className='replacements-td'>
                    <Tooltip title="Dodaj zamenjavo" arrow placement='top'>
                      <button onClick={addReplacementToList}>
                        <AddIcon id="add_replacement_icon" />
                      </button>
                    </Tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div id="replacements_footer">
            <input
              type="file"
              accept=".tsv"
              ref={replacementsFileInputRef}
              onChange={importReplacementTsv}
              style={{ display: 'none' }} />
            <button disabled={updating} onClick={exportReplacementsTsv} className='button_replacements_secondary'>Izvozi</button>
            <button disabled={updating} onClick={() => replacementsFileInputRef.current?.click()} className='button_replacements_secondary'>Naloži</button>
            <button disabled={updating} onClick={saveReplacements} className='button_replacements_primary'>Shrani</button>
          </div>
        </div>
        
      </Modal>
    )
}

export default ReplacementModal;